var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0001 17.0001C8.55238 17.0001 9.0001 16.5524 9.0001 16.0001C9.0001 15.4478 8.55238 15.0001 8.0001 15.0001C7.44781 15.0001 7.0001 15.4478 7.0001 16.0001C7.0001 16.5524 7.44781 17.0001 8.0001 17.0001Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7001 2.1001C17.4598 2.1001 17.2295 2.19616 17.0605 2.36691L10.2608 9.23529C9.85401 9.14667 9.43208 9.1001 9.0001 9.1001C5.74162 9.1001 3.1001 11.7416 3.1001 15.0001C3.1001 18.2586 5.74162 20.9001 9.0001 20.9001C12.2586 20.9001 14.9001 18.2586 14.9001 15.0001C14.9001 14.5646 14.8312 14.0297 14.7331 13.5373C14.691 13.326 14.641 13.1094 14.5839 12.9001H16.0001C16.4972 12.9001 16.9001 12.4972 16.9001 12.0001V10.4001H18.0001C18.4972 10.4001 18.9001 9.99715 18.9001 9.5001V7.9001H20.0001C20.4972 7.9001 20.9001 7.49715 20.9001 7.0001V3.0001C20.9001 2.50304 20.4972 2.1001 20.0001 2.1001H17.7001ZM11.1727 10.8727L18.0755 3.9001H19.1001V6.1001H18.0001C17.503 6.1001 17.1001 6.50304 17.1001 7.0001V8.6001H16.0001C15.503 8.6001 15.1001 9.00304 15.1001 9.5001V11.1001H14.0001C13.7614 11.1001 13.5325 11.1949 13.3637 11.3637L12.8637 11.8637C12.6018 12.1256 12.5271 12.5211 12.6754 12.8604C12.7725 13.0826 12.8822 13.4592 12.9678 13.8889C13.0528 14.3156 13.1001 14.7245 13.1001 15.0001C13.1001 17.2645 11.2645 19.1001 9.0001 19.1001C6.73573 19.1001 4.9001 17.2645 4.9001 15.0001C4.9001 12.7357 6.73573 10.9001 9.0001 10.9001C9.44016 10.9001 9.86235 10.9691 10.2574 11.0962C10.5803 11.2001 10.9341 11.1137 11.1727 10.8727Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyOutline);
export default __webpack_public_path__ + "static/media/key_outline.39685c92ef608652f722c086fad82392.svg";
export { ForwardRef as ReactComponent };